import { Instruction, OpCode } from '../internal.js';
/**
 * Load By Id Instruction.
 *
 * Loads an instance by the given Jig Id.
 */
export class LoadByOriginInstruction extends Instruction {
    origin;
    constructor(origin) {
        super(OpCode.LOADBYORIGIN);
        this.origin = origin;
    }
}
/**
 * Load By Origin Args Serializer object - implements the Serializable interface.
 */
export const LoadByOriginArgsSerializer = {
    read(buf) {
        const origin = buf.readFixedBytes(34);
        return new LoadByOriginInstruction(origin);
    },
    write(buf, instruction) {
        buf.writeFixedBytes(instruction.origin);
        return buf;
    }
};
